import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { JourneyTimeline } from './JourneyTimeline';
import { Mail, Smartphone, QrCode, Calendar, Globe, MessageSquare, Megaphone, Users, ExternalLink } from 'lucide-react';
import { Play } from 'lucide-react';
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0
  }
};
const channels = [{
  icon: Globe,
  label: 'Embed',
  color: '#1B4F72'
}, {
  icon: Smartphone,
  label: 'SMS',
  color: '#1B4F72'
}, {
  icon: MessageSquare,
  label: 'WhatsApp',
  color: '#25D366'
}, {
  icon: QrCode,
  label: 'QR Code',
  color: '#1B4F72'
}, {
  icon: Megaphone,
  label: 'Social',
  color: '#1B4F72'
}, {
  icon: Mail,
  label: 'Email',
  color: '#5B8FAF'
}, {
  icon: Play,
  label: 'Ads',
  color: '#1B4F72'
}, {
  icon: Users,
  label: 'Congress',
  color: '#1B4F72'
}];
const channelContainer = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.04,
      delayChildren: 0.2
    }
  }
};
const channelItem = {
  hidden: {
    opacity: 0,
    scale: 0.8
  },
  show: {
    opacity: 1,
    scale: 1
  }
};
export function SlideBeforeCongress() {
  const [imgError, setImgError] = useState(false);
  return <div className="h-full w-full bg-[#EDF4F8] text-[#1B4F72] p-8 md:p-12 flex flex-col" data-id="element-131">
      <JourneyTimeline currentStage={1} data-id="element-132" />

      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-4 border-l-4 border-[#5B8FAF] pl-6" data-id="element-133">
        <div className="flex items-center gap-3 mb-1" data-id="element-134">
          <span className="text-3xl" data-id="element-135">🎯</span>
          <h2 className="text-2xl font-bold text-[#1B4F72]" data-id="element-136">Before Congress</h2>
        </div>
        <p className="text-lg text-[#5B8FAF] font-medium" data-id="element-137">
          Goal: Build anticipation and pre-qualify interest
        </p>
      </motion.div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-[1fr_1fr] gap-4 min-h-0" data-id="element-138">
        {/* Left Column: Tactics + Features */}
        <div className="flex flex-col gap-3 overflow-auto" data-id="element-139">
          <motion.div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100" variants={container} initial="hidden" animate="show" data-id="element-140">
            <h3 className="text-sm font-bold text-[#1B4F72] mb-2 flex items-center gap-2" data-id="element-141">
              <span className="w-6 h-1 bg-[#5B8FAF] rounded-full" data-id="element-142"></span>
              Tactics
            </h3>
            <ul className="space-y-2" data-id="element-143">
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-144">
                <Mail className="w-3.5 h-3.5 text-[#5B8FAF] mt-0.5 shrink-0" data-id="element-145" />
                <span className="text-gray-700 text-xs" data-id="element-146">
                  Email campaigns & banners driving traffic
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-147">
                <Smartphone className="w-3.5 h-3.5 text-[#5B8FAF] mt-0.5 shrink-0" data-id="element-148" />
                <span className="text-gray-700 text-xs" data-id="element-149">
                  Snaks™ embedded in landing pages and portals
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-150">
                <QrCode className="w-3.5 h-3.5 text-[#5B8FAF] mt-0.5 shrink-0" data-id="element-151" />
                <span className="text-gray-700 text-xs" data-id="element-152">
                  QR codes on print & digital invites
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-153">
                <Calendar className="w-3.5 h-3.5 text-[#5B8FAF] mt-0.5 shrink-0" data-id="element-154" />
                <span className="text-gray-700 text-xs" data-id="element-155">
                  Early opt-in via teaser Snak™
                </span>
              </motion.li>
            </ul>
          </motion.div>

          <motion.div className="bg-[#5B8FAF]/5 p-3 rounded-xl border border-[#5B8FAF]/10" variants={container} initial="hidden" animate="show" data-id="element-156">
            <h3 className="text-sm font-bold text-[#1B4F72] mb-2 flex items-center gap-2" data-id="element-157">
              <span className="w-6 h-1 bg-[#7CB9D8] rounded-full" data-id="element-158"></span>
              Snakker™ Features
            </h3>
            <ul className="space-y-2" data-id="element-159">
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-160">
                <div className="w-1.5 h-1.5 rounded-full bg-[#7CB9D8] mt-1.5 shrink-0" data-id="element-161" />
                <span className="text-gray-700 text-xs" data-id="element-162">
                  <strong className="text-[#1B4F72]" data-id="element-163">Teaser Snaks™</strong>{' '}
                  with Menu and Poll Cues
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-164">
                <div className="w-1.5 h-1.5 rounded-full bg-[#7CB9D8] mt-1.5 shrink-0" data-id="element-165" />
                <span className="text-gray-700 text-xs" data-id="element-166">
                  Personalized journeys using{' '}
                  <strong className="text-[#1B4F72]" data-id="element-167">Splits</strong>
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-2" data-id="element-168">
                <div className="w-1.5 h-1.5 rounded-full bg-[#7CB9D8] mt-1.5 shrink-0" data-id="element-169" />
                <span className="text-gray-700 text-xs" data-id="element-170">
                  Calendar links, digital contact card exchange
                </span>
              </motion.li>
            </ul>
          </motion.div>
        </div>

        {/* Right Column: Channel Grid (compact) + WhatsApp Phone Mockup */}
        <motion.div className="flex flex-col gap-3 min-h-0" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-171">
          {/* Compact channel grid */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-3" data-id="element-172">
            <h3 className="text-xs font-bold text-[#1B4F72] mb-2 text-center" data-id="element-173">
              Deliver Snaks™ Anywhere
            </h3>
            <motion.div className="grid grid-cols-4 gap-1.5" variants={channelContainer} initial="hidden" animate="show" data-id="element-174">
              {channels.map((ch, i) => {
              const Icon = ch.icon;
              return <motion.div key={i} variants={channelItem} className="flex flex-col items-center gap-1 bg-[#EDF4F8] rounded-lg px-1.5 py-1.5" data-id="element-175">
                    <div className="w-5 h-5 rounded flex items-center justify-center" style={{
                  backgroundColor: `${ch.color}15`
                }} data-id="element-176">
                      <Icon className="w-3 h-3" style={{
                    color: ch.color
                  }} data-id="element-177" />
                    </div>
                    <span className="text-[8px] font-medium text-[#1B4F72]" data-id="element-178">
                      {ch.label}
                    </span>
                  </motion.div>;
            })}
            </motion.div>
          </div>

          {/* WhatsApp Phone Mockup */}
          <motion.div className="flex-1 flex items-center justify-center min-h-0" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} data-id="element-179">
            <div className="relative w-[200px] shrink-0" data-id="element-180">
              <div className="bg-[#1a1a1a] rounded-[24px] p-[5px] shadow-2xl" data-id="element-181">
                <div className="absolute top-[5px] left-1/2 -translate-x-1/2 w-16 h-4 bg-[#1a1a1a] rounded-b-lg z-20" data-id="element-182" />
                <div className="bg-white rounded-[20px] overflow-hidden" data-id="element-183">
                  {/* WhatsApp header */}
                  <div className="bg-[#1B4F72] px-3 py-2 pt-6 flex items-center gap-1.5" data-id="element-184">
                    <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center overflow-hidden" data-id="element-185">
                      <img src="https://cdn.magicpatterns.com/uploads/4DGmJHhWeAjxRuZESUmMjZ/Bayer-Logo.wine.svg" alt="Bayer" className="h-3.5 w-auto" data-id="element-186" />
                    </div>
                    <div data-id="element-187">
                      <p className="text-white text-[8px] font-semibold" data-id="element-188">
                        Bayer
                      </p>
                      <p className="text-white/50 text-[6px]" data-id="element-189">
                        Business account
                      </p>
                    </div>
                  </div>
                  {/* Disclaimer */}
                  <div className="bg-[#EDF4F8] px-2 py-1 flex items-center justify-center gap-1" data-id="element-190">
                    <ExternalLink className="w-2 h-2 text-[#5B8FAF]" data-id="element-191" />
                    <span className="text-[6px] text-[#5B8FAF] font-medium" data-id="element-192">
                      NUBEQA® Disclaimer
                    </span>
                  </div>
                  {/* Chat */}
                  <div className="px-2 py-2 min-h-[180px]" style={{
                  backgroundColor: '#ECE5DD'
                }} data-id="element-193">
                    <div className="flex justify-center mb-2" data-id="element-194">
                      <span className="bg-white/80 text-[6px] text-gray-500 font-medium px-2 py-0.5 rounded-full" data-id="element-195">
                        Today
                      </span>
                    </div>
                    <div className="bg-white rounded-md rounded-tl-none shadow-sm p-2 max-w-[95%]" data-id="element-196">
                      <div className="rounded overflow-hidden mb-1.5" data-id="element-197">
                        <div className="bg-gradient-to-br from-[#1B4F72] to-[#5B8FAF] p-2 relative overflow-hidden" data-id="element-198">
                          <div className="absolute top-0 right-0 w-10 h-10 bg-[#7CB9D8]/15 rounded-bl-[20px]" data-id="element-199" />
                          <div className="flex justify-end mb-1" data-id="element-200">
                            <span className="text-white text-[6px] font-bold tracking-wider" data-id="element-201">
                              NUBEQA®
                            </span>
                          </div>
                          <p className="text-white font-bold text-[7px] leading-tight mb-1 max-w-[85%]" data-id="element-202">
                            How does early intervention with darolutamide impact
                            survival?
                          </p>
                          <p className="text-white/70 text-[5px] leading-snug max-w-[85%]" data-id="element-203">
                            Explore the latest evidence on metastasis-free
                            survival.
                          </p>
                        </div>
                        <div className="bg-[#EDF4F8] px-2 py-1 flex items-center gap-1" data-id="element-204">
                          <div className="w-3.5 h-3.5 rounded-full bg-[#1B4F72] flex items-center justify-center" data-id="element-205">
                            <Play className="w-1.5 h-1.5 text-white fill-white ml-px" data-id="element-206" />
                          </div>
                          <span className="text-[6px] font-semibold text-[#1B4F72]" data-id="element-207">
                            NUBEQA WA link
                          </span>
                        </div>
                      </div>
                      <p className="text-[7px] font-semibold text-gray-900 mb-0.5" data-id="element-208">
                        Dear Doctor,
                      </p>
                      <p className="text-[6px] text-gray-600 leading-snug mb-1" data-id="element-209">
                        Explore the latest survival data and safety profile
                        behind NUBEQA®.
                      </p>
                      <div className="border-t border-gray-100 pt-1 flex items-center justify-center gap-1" data-id="element-210">
                        <Play className="w-2 h-2 text-[#5B8FAF]" data-id="element-211" />
                        <span className="text-[7px] text-[#5B8FAF] font-medium" data-id="element-212">
                          Learn More
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>;
}